module.exports = __webpack_public_path__ + "img/info-03.f047faf5.jpg";